import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { TemplateFormat } from "@/schemas/prompt";

interface FormatSelectorProps {
  formats: string[];
  currentFormat: string;
  onChange?: (format: TemplateFormat) => void;
  readonly?: boolean;
}

const FormatSelector = ({ formats, currentFormat, onChange, readonly }: FormatSelectorProps) => (
  <Select value={currentFormat} disabled={readonly} onValueChange={onChange}>
    <SelectTrigger className="truncate whitespace-nowrap">{currentFormat}</SelectTrigger>
    <SelectContent>
      {formats.map(format => (
        <SelectItem key={format} value={format}>
          {format}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default FormatSelector;
